import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import * as React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { RemittanceRunnerListUrlQueryParams } from "./url";
import RemittanceRunnerDetailsComponent from "./views/RemittanceRunnerDetails";
import RemittanceRunnerListComponent from "./views/RemittanceRunnerList";
import RemittanceRunnerToRemitComponent from "./views/RemittanceRunnerToRemit";

const RemittanceRunnerList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: RemittanceRunnerListUrlQueryParams = qs;

  return <RemittanceRunnerListComponent params={params} />;
};

const RemittanceRunnerDetails: React.FC = () => {
  const { id } = useParams();
  return <RemittanceRunnerDetailsComponent id={decodeURIComponent(id)} />;
};

const RemittanceRunnerToRemit: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: RemittanceRunnerListUrlQueryParams = qs;

  return <RemittanceRunnerToRemitComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.remittanceRunner)} />
      <Routes>
        <Route path={"remittances"} element={<RemittanceRunnerList />} />
        <Route path={"remittances/:id"} element={<RemittanceRunnerDetails />} />
        <Route path={"to-remit"} element={<RemittanceRunnerToRemit />} />
      </Routes>
    </>
  );
};

export default Component;
